import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';
import { toast } from 'react-toastify';

const useStatistic = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getStatisticView = async reqData => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/statistic/viewformat',
          method: 'POST',
          headers: authCtx.getAuthHeaders(),
          body: { ...reqData },
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const getStatisticDaterange = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/statistic/dateRange',
          method: 'GET',
          headers: authCtx.getAuthHeaders(),
        });

        resolve(responseData);
      } catch (error) {
        reject(error);
      }
    });
  };

  const getSelfServiceStatistic = async (startDate, endDate) => {
    try {
      return await sendRequest({
        url: '/api/v1/statistic/selfService',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params: {
          startDate,
          endDate,
        },
      });
    } catch (e) {
      toast.error('Fehler beim Laden der Self Service Statistik');
      throw e;
    }
  };

  const getCallCenterStatistic = async (startDate, endDate) => {
    try {
      return await sendRequest({
        url: '/api/v1/statistic/callCenter',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params: {
          startDate,
          endDate,
        },
      });
    } catch (e) {
      toast.error('Fehler beim Laden der Call Center Statistik');
      throw e;
    }
  };

  const getDemographyStatistic = async (startDate, endDate, branchId) => {
    try {
      const params = {
        startDate,
        endDate,
      };
      if (branchId) params.branchId = branchId;
      return await sendRequest({
        url: '/api/v1/statistic/demography',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params,
      });
    } catch (e) {
      toast.error('Fehler beim Laden der Demografie-Statistik');
      throw e;
    }
  };

  const getBookingOriginStatistic = async (startDate, endDate, branchId) => {
    try {
      const params = {
        startDate,
        endDate,
      };
      if (branchId) params.branchId = branchId;
      return await sendRequest({
        url: '/api/v1/statistic/bookingOrigin',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
        params,
      });
    } catch (e) {
      toast.error('Fehler beim Laden der Buchungsherkunft-Statistik');
      throw e;
    }
  };

  return {
    isLoading,
    error,
    getStatisticView,
    getStatisticDaterange,
    getSelfServiceStatistic,
    getCallCenterStatistic,
    getDemographyStatistic,
    getBookingOriginStatistic,
  };
};

export default useStatistic;
